import _ from 'lodash';

import MasterService from '../../app/common/master.service';

const FLASHMESSAGE_KEY = Symbol('flashmessage');
const CLOSE_FLASHMESSAGE_KEY = Symbol('closeflashmessage');

/**
 * Show message after this many milliseconds. This delay is required for the
 * animations to work, as just inserting to DOM will pop up the notification
 * instantly. A value of 0 works for single notifications but fails if there
 * are multiple. This value seems to work fine for multiple notifications
 * without inserting a perceptible delay.
 * @type {number}
 */
const FlashMessageShowDelay = 50;
const FlashMessageRemoveDelay = 22550;


/**
 * This module provides a simple flash message service, where you can add messages
 * with custom classes that are shown with an animation and hidden after a timeout.
 */
class FlashMessageService extends MasterService {
  constructor($log) {
    'ngInject';

    super();

    this.$log = $log;
    this._addKey(FLASHMESSAGE_KEY);
    this._addKey(CLOSE_FLASHMESSAGE_KEY);
    this._id = 0;
  }

  /**
   * Subscribe to be notified of when the flashmessage status changes.
   * @param {function} callback
   */
  subscribeFlashmessage(callback) {
    this._subscribe(FLASHMESSAGE_KEY, callback);
  }

  subscribeCloseFlashmessage(callback) {
    this._subscribe(CLOSE_FLASHMESSAGE_KEY, callback)
  }

  addMessage(content, classes) {
    if (_.isUndefined(classes)) {
      classes = ['success'];
    }
    else if (!_.isArray(classes)) {
      classes = [classes];
    }

    this.$log.debug("FlashmessageService message:", content, classes);

    let messageId = this._id++;

    const data = {
      content,
      classes,
      id: messageId
    };

    this._setValue(FLASHMESSAGE_KEY, data);
    return messageId
  }

  closeMessage(msgId) {
    this._setValue(CLOSE_FLASHMESSAGE_KEY, msgId)
  }

}

const mod = angular.module('flashmessage', [])

.service('FlashMessageService', FlashMessageService);


export {
  FlashMessageShowDelay,
  FlashMessageRemoveDelay,
  FLASHMESSAGE_KEY
};

export default mod.name;



// WEBPACK FOOTER //
// ./src/common/flashmessageservice/flashmessageservice.module.js